import type { SlateBlock, SlateLeaf } from '@atlas/renderer';
import { Element, Text } from 'slate';

export default function areBlockLeavesEmpty(block: SlateBlock): boolean {
    return (block.children as Array<SlateBlock | SlateLeaf>).every((child) => {
        if (Element.isElement(child)) return areBlockLeavesEmpty(child);
        if (Text.isText(child)) return !child.text.length;
        return false;
    });
}

// #region Tests

if (import.meta.vitest) {
    const { describe, it } = import.meta.vitest;
    describe('areBlockLeavesEmpty', () => {
        it.todo('🤷🏼');
    });
}

// #endregion
